/**
 * Return construct a url for a background image
 * e.g. www.heygirl.cutestperson.com/assets/image.jpg ->
 * url("www.heygirl.cutestperson.com/assets/image.jpg")
 * @param {string} url - The image URL to format for CSS background-image
 */
export const backgroundImageForUrl = <T>(url: T) => {
  try {
    if (url && typeof url === 'string') {
      const encodedUrl = new URL(url).toString();
      return `url("${encodedUrl}")`;
    }
    return url;
  } catch (error) {
    console.error('Error encoding background image URL', error);
    return `url("${url}")`;
  }
};

export const backgroundImageWithDarkOverlay = <T>(url: T) => {
  if (url && typeof url === 'string') {
    return ['linear-gradient(rgba(0, 0, 0, 0.32), rgba(0, 0, 0, 0.32))', !!url && typeof url === 'string' && `url("${url}")`, 'linear-gradient(rgba(0, 0, 0, 1), rgba(0, 0, 0, 1))']
      .filter(Boolean)
      .join(', ');
  }
  return url;
};
